<template>
  <div class="auth-success-page">
    <v-app>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card max-width="600px">
          <v-card-text>
            <div>
              <v-layout class="test-success-warning">
                <v-avatar
                  :color="title == 'SuccessPage' ? 'green' : 'red'"
                  size="70"
                >
                  <v-icon color="white" size="50">{{
                    title == 'SuccessPage' ? 'check' : 'close'
                  }}</v-icon>
                </v-avatar>
              </v-layout>
              <v-layout class="test-success-warning mt-2">
                <strong>
                  {{ title == 'SuccessPage' ? 'All Done For Now!' : 'Error!' }}
                </strong>
              </v-layout>
              <v-layout class="test-success-warning mt-2">
                <div>
                  {{
                    title == 'SuccessPage'
                      ? 'Success! Please close this tab.'
                      : 'Test failed in Callback Validation. Please check your configuration.'
                  }}
                </div>
              </v-layout>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-app>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dialog: true,
    };
  },
};
</script>

<style lang="scss">
.auth-success-page {
  .v-dialog > .v-card > .v-card__title {
    background-color: white !important;
  }
  .test-success-warning {
    justify-content: center;
  }
}
</style>
